<div
  class="select input"
  [ngClass]="{
    'input--highlight': highlightError | async,
    'input--icon': !!selectorIcon,
    'select--has-value': alwaysShowValue || (internalControl.value !== undefined && internalControl.value !== null),
    'select--menu-open': isOpen,
    'select--display': !isOpen,
    'select--disabled': !enabled,
    'select--invalid': !internalControl.valid,
    'input--invalid': !internalControl.valid,
    'select--touched': internalControl.touched,
    'input--touched': internalControl.touched,
    'select--hide-label': !!hideLabel,
    'select--search-type': searchType,
  }"
  (clickOutside)="close()"
  [openState]="isOpen"
>
  <div class="select__value-container">
    @if (selectorIcon) {
      <ftr-icon-legacy class="input__icon" [icon]="selectorIcon" color="GreyLight" />
    }
    <div
      #selectValue
      tabindex="0"
      class="select__button"
      role="button"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
      [attr.aria-labelledby]="id + '-expand-label'"
      [attr.aria-activedescendant]="isOpen ? activeDescendantId : null"
      (click)="open()"
    >
      Select {{ singular }}
    </div>
    <div class="select__value">
      {{ selectedLabel }}
    </div>
    <label [id]="id + '-expand-label'" class="select__label" [for]="selectValue">{{ label }}</label>
    <span class="select__bar input__bar"></span>
    <ftr-icon-legacy class="select__arrow select__arrow--right" icon="ChevronRight" />
    @if (!searchType) {
      <ftr-icon-legacy class="select__arrow select__arrow--down" icon="ArrowDown" />
    }
    @if (searchType) {
      <ftr-icon-legacy class="select__arrow select__arrow--down" icon="ChevronDown" />
    }
    <span
      class="input__validation select__validation"
      ftrValidationErrorHint
      [label]="label"
      [ngFormControl]="internalControl"
      [controlTouched]="internalControl.touched"
      [submitAttempted]="submitAttempted"
    ></span>
  </div>
  @if (items$ | async; as items) {
    <div
      class="select__open-menu-container"
      role="listbox"
      [attr.aria-required]="required"
      [attr.aria-labelledby]="id + '-label'"
    >
      <div class="select__input-container">
        <button type="button" ftrButton displayType="icon" class="select__close" (click)="close()">
          <ftr-icon-legacy icon="ChevronLeft" />
        </button>
        <span class="select__opened-label" [id]="id + '-label'">Select {{ singular }}</span>
      </div>
      <div class="select__items" [id]="id">
        @for (item of items; track item; let i = $index) {
          <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- it is focusable -->
          <div
            class="select__item"
            [ngClass]="{
              'select__item--selected': item.value === internalControl.value,
            }"
            role="option"
            [id]="id + '-item-' + i"
            [attr.aria-selected]="item.value === internalControl.value"
            (click)="setValue(item.value)"
            (keydown.enter)="setValue(item.value)"
          >
            {{ item.key }}
          </div>
        }
      </div>
    </div>
  }
</div>
